import React from 'react';
import { Button } from '../../Utility/Button';
import Input from '../../Utility/FormElements/Input';
import AdminContainer from '../../Utility/AdminContainer';
import AdminBox from '../../Utility/AdminBox';
import AdminBoxHeadline from '../../Utility/AdminBoxHeadline';
import { RootState, useAppSelector } from '../../../store';
import useCredential from '../../../Hooks/useCredential';
import Select from '../../Utility/FormElements/Select';

function Credential() {
    const i18n = useAppSelector((state: RootState) => state.i18n.i18n);
    const {
        CredentialActions,
        credentialIdentifier,
        name,
        parameters,
        providerIdentifier,
        providers,
        credentialLoaded,
    } = useCredential();

    return Object.keys(providers).length > 0 ? (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <AdminBox contentLoaded={credentialLoaded}>
                    <>
                        <div className="w-full flex gap-8 flex-col">
                            <AdminBoxHeadline
                                headLine={i18n.translate({
                                    id: credentialIdentifier === 'new' ? 'newCredential' : 'editCredential',
                                    sourceName: 'Credential',
                                })}
                                subLine={credentialIdentifier === 'new' ? undefined : name.toString()}
                            />

                            <div>
                                <label htmlFor="apiKeyNameInput" className="block mb-2">
                                    {i18n.translate({ id: 'label.name', sourceName: 'Credential' })}
                                </label>
                                <Input
                                    inputType="text"
                                    value={name?.toString() ?? ''}
                                    onChange={CredentialActions.handleNameChange}
                                    id="apiKeyNameInput"
                                />
                            </div>

                            <div>
                                <label htmlFor="providerSelect" className="block mb-2">
                                    {i18n.translate({ id: 'label.provider', sourceName: 'Credential' })}
                                </label>
                                <Select
                                    id="providerSelect"
                                    onChange={CredentialActions.setProviderIdentifier}
                                    value={providerIdentifier}
                                >
                                    <option key="---" value="">
                                        {i18n.translate({ id: 'provider.option.select', sourceName: 'Credential' })}
                                    </option>
                                    {providers.map((provider) => (
                                        <option key={provider.identifier} value={provider.identifier}>
                                            {provider.name}
                                        </option>
                                    ))}
                                </Select>
                            </div>

                            {providers.find((provider) => provider.identifier === providerIdentifier)?.options &&
                                Object.entries(
                                    providers.find((provider) => provider.identifier === providerIdentifier)?.options ||
                                        {},
                                ).map(([optionKey, option]) => {
                                    const isHiddenField = option.hidden === true;
                                    return (
                                        <div key={optionKey}>
                                            <label htmlFor={optionKey} className="block mb-2">
                                                {option.label} {option.required && '*'}
                                            </label>
                                            {option.type === 'string' && (
                                                <Input
                                                    id={optionKey}
                                                    inputType={isHiddenField ? 'password' : 'text'}
                                                    hasVisibilityButton={isHiddenField}
                                                    onChange={(value) =>
                                                        CredentialActions.handleParameterChange(optionKey, value)
                                                    }
                                                    value={parameters[optionKey] ?? ''}
                                                    placeholder={option.default ?? option.placeholder}
                                                />
                                            )}
                                        </div>
                                    );
                                })}
                        </div>
                        <div className="mt-5 flex gap-2">
                            {providerIdentifier && (
                                <span className="text-sm text-gray-500">
                                    * {i18n.translate({ id: 'required', sourceName: 'Credential' })}
                                </span>
                            )}
                            <Button
                                variant="primary"
                                className="ml-auto"
                                onClick={() => CredentialActions.handleSave(name)}
                            >
                                {i18n.translate({ id: 'save', sourceName: 'Main' })}
                            </Button>
                        </div>
                    </>
                </AdminBox>
            </AdminContainer>
        </div>
    ) : (
        <></>
    );
}

export default Credential;
